module.exports = __webpack_public_path__ + "img/ic_app_instroduce_num.9a752af1.png";